import { takeLatest } from "redux-saga/effects";
import { defaultReturn, generateDefaultActions, makePayload, requestSaga } from "shared-utility/store/utils/helpers";

export const TREASURY_SNAPSHOT_GET_HISTORICAL_DATA_BY_SYMBOL = generateDefaultActions("TREASURY_SNAPSHOT_GET_HISTORICAL_DATA_BY_SYMBOL");
export const treasurySnapshotGetHistoricalDataBySymbol = payload => makePayload(TREASURY_SNAPSHOT_GET_HISTORICAL_DATA_BY_SYMBOL.value, payload);
function* treasurySnapshotGetHistoricalDataBySymbolSaga(payload) {
  const { symbol } = payload;
  const url = `/treasurySnapshot/historical/${encodeURI(symbol)}`;
  yield requestSaga(TREASURY_SNAPSHOT_GET_HISTORICAL_DATA_BY_SYMBOL, url);
}

export const TREASURY_SNAPSHOT_GET_LATEST_RATE_BY_SYMBOL = generateDefaultActions("TREASURY_SNAPSHOT_GET_LATEST_RATE_BY_SYMBOL");
export const treasurySnapshotGetLatestRateBySymbol = payload => makePayload(TREASURY_SNAPSHOT_GET_LATEST_RATE_BY_SYMBOL.value, payload);
function* treasurySnapshotGetLatestRateBySymbolSaga(payload) {
  const { symbol } = payload;
  const url = `/treasurySnapshot/historical/latest/${encodeURI(symbol)}`;
  yield requestSaga(TREASURY_SNAPSHOT_GET_LATEST_RATE_BY_SYMBOL, url);
}

const initialState = {
  treasurySnapshot: [],
  latestRate: []
};

export const treasurySnapshotReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TREASURY_SNAPSHOT_GET_HISTORICAL_DATA_BY_SYMBOL.success:
      return defaultReturn(state, payload, "treasurySnapshot");
    case TREASURY_SNAPSHOT_GET_LATEST_RATE_BY_SYMBOL.success:
      return defaultReturn(state, payload, "latestRate");
    default:
      return state;
  }
};

export function* treasurySnapshotSaga() {
  yield takeLatest(TREASURY_SNAPSHOT_GET_HISTORICAL_DATA_BY_SYMBOL.value, treasurySnapshotGetHistoricalDataBySymbolSaga);
  yield takeLatest(TREASURY_SNAPSHOT_GET_LATEST_RATE_BY_SYMBOL.value, treasurySnapshotGetLatestRateBySymbolSaga);
}
